import useJwt from '@core/auth/jwt/useJwt'
import axios from '@axios'
import jwtConfig from './config'

const { jwt } = useJwt(axios, jwtConfig)
export default jwt
